<script>
import { tableRelevant } from "@/pages/projectImpl/js/utils";

export default {
  name: "SelectCourse",
  props: {
    organizationId: Number,
    confirmLoading: Boolean,
    disabledData: {
      type: Array,
      default: function() {
        return []
      },
    },
    title: {
      type: String,
      default: "选择课程",
    },
    selectType: {
      type: String,
      default: "checkbox",
    },
    courseType: Number,
    visible: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: "visible",
    event: "visible",
  },
  data() {
    return {
      organizationList: [],
      resourceList: [],
      searchForm: {
        organizationId: undefined,
        courseName: undefined,
        courseResourceName: undefined,
        period: undefined,
      },
      //表格相关
      columns: [
        { title: "课程名称", dataIndex: "name" },
        { title: "学段", dataIndex: "period" },
        { title: "课程类型", scopedSlots: { customRender: "courseType" } },
        { title: "资源名称", dataIndex: "courseResourceName" },
        { title: "课时数", dataIndex: "courseSessionCount" },
        { title: "学生数", dataIndex: "configuredUserCount" },
        { title: "课程进度", scopedSlots: { customRender: "statusName" } },
      ].filter(f => !(this.courseType && f.title === '课程类型')),
      table: tableRelevant.call(this),
    };
  },
  computed: {
    rowSelection() {
      return {
        type: this.selectType,
        selectedRowKeys: this.table.selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          this.table.selectedRowKeys = selectedRowKeys;
          this.table.selectedRows = selectedRows.concat(this.table.selectedRows).reduce((pre, cur) => {
            if (!pre.some((s) => s.id === cur.id)) {
              pre.push(cur);
            }
            return pre;
          }, []);
        },
        getCheckboxProps: (record) => {
          return {
            props: {
              disabled: this.disabledData.includes(record.id) || record.source === 1,
            },
          };
        },
      };
    },
  },
  watch: {
    visible(bool) {
      if (bool) {
        this.getOrganizationList();
      }
    }
  },
  methods: {
    //获取列表
    getPageList(pageIndex) {
      const params = {
        ...this.searchForm,
        enabled: true,
        courseType: this.courseType,
        pageIndex: pageIndex || this.table.tablePagination.current,
        pageSize: this.table.tablePagination.pageSize,
      };
      this.table.tableLoading = true;
      this.$http.CourseService.OrganizationCourseList(params).then((res) => {
        this.table.tableDataSource = res.data.items;
        this.table.tablePagination.total = res.data.totalCount;
        this.table.tablePagination.current = res.data.pageIndex;
      }).finally(() => {
        this.table.tableLoading = false;
      });
    },
    getResourceList(organizationId){
      if (!this.searchForm.organizationId) {
        this.resourceList = [];
        this.searchForm.courseResourceName = undefined;
        this.table = tableRelevant.call(this);
        return
      }
      this.getPageList(1);
      this.searchForm.courseResourceName = undefined;
      this.$http.CourseService.getCourseResources({
        CourseType: this.courseType,
        pageIndex: 1,
        pageSize: 9999,
        organizationId: organizationId,
      }).then((res) => {
        this.resourceList = res.data.items;
      });
    },
    // 获取机构列表
    getOrganizationList() {
      this.$http.loadAllByType({ isOnlySuperior: false, orgType:1 }).then((res) => {
        this.organizationList = res.data.data;
        if (this.organizationList.length) {
          this.searchForm.organizationId = this.organizationList[0].id;
          this.getResourceList(this.searchForm.organizationId);
          this.getPageList(1);
        }
      });
    },

    modalOk() {
      this.$emit("ok", this.table.selectedRows);
      this.modalCancel();
    },
    modalCancel() {
      this.$emit("visible", false);
      for (let searchFormKey in this.searchForm) {
        this.searchForm[searchFormKey] = undefined;
      }
      this.table = tableRelevant.call(this);
    },
  },
};
</script>

<template>
  <a-modal :visible="visible" :confirm-loading="confirmLoading" @cancel="modalCancel" @ok="modalOk" :title="title" width="75%">
    <a-form-model layout="inline" class="search-form">
      <a-form-model-item label="机构名称">
        <a-select v-model="searchForm.organizationId" allow-clear
          optionFilterProp="title" @change="getResourceList"
          showSearch placeholder="请选择机构">
          <a-select-option :value="item.id" :title="item.name" v-for="item in organizationList">
            {{ item.name}}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="课程名称">
        <a-input placeholder="请输入课程名称" allow-clear :maxLength="20" v-model="searchForm.courseName" />
      </a-form-model-item>
      <a-form-model-item label="资源名称">
        <a-select @change="e => searchForm.courseResourceName = e.split('_')[0]" allowClear placeholder="请选择资源">
          <a-select-option v-for="item in resourceList" :key="item.id" :value="item.name + '_' + item.id">{{ item.name }} </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="学段">
        <a-select v-model="searchForm.period" allowClear placeholder="请选择学段">
          <a-select-option v-for="item in $data._period" :value="item" :key="item">{{ item }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-item>
        <a-button @click="getPageList(1)" type="primary">查询</a-button>
      </a-form-item>
    </a-form-model>
    <a-table
      :columns="columns"
      :scroll="{ y: 300 }"
      style="min-width: 800px"
      row-key="id"
      :row-selection="rowSelection"
      :pagination="table.tablePagination"
      :loading="table.tableLoading"
      :locale="table.locale"
      :dataSource="table.tableDataSource">
      <div slot="courseType" slot-scope="text">
        {{['', '测评课程', '训练课程', '活动课程'][text.courseType]}}
      </div>
      <div slot="statusName" class="table-progress"  slot-scope="text">
        <a-badge v-if="text.statusName === '未开始'" status="warning" />
        <a-badge v-if="text.statusName === '进行中'" status="processing" />
        <a-badge v-if="text.statusName === '已完成'" status="success" />
        <a-badge v-if="text.statusName === '已过期'" status="default" />
        {{ text.statusName }}
        <a-icon type="check-circle" v-if="text.statusName === '已完成'" style="color: #52c41a; margin-left: 5px" />
        <span v-if="!['未开始', '已完成'].includes(text.statusName)" style="margin-left: 5px">{{ text.progress }}%</span>
      </div>
    </a-table>
  </a-modal>
</template>

<style scoped lang="less">
.table-progress {
  display: flex;
  align-items: center;
  white-space: nowrap;

  .ant-progress {
    flex: 1 1 auto;
    margin: 0;
  }
}
</style>
